import { notification } from "antd";
import { ICrmLeadAnotacaoDTO } from "../../models/happy-code-api.model";
import { useLeadAnotacaoService } from "../../services/lead-anotacao.service";

const useLeadScreenState = () => {

  const anotacaoService = useLeadAnotacaoService();

  const salvarAnotacao = (body: ICrmLeadAnotacaoDTO) => {
    return anotacaoService.create(body)
      .then(() => {
        notification.success({ message: 'Anotação cadastrada com sucesso', type: 'success', placement: "bottomRight" });
      });
  }

  return {
    salvarAnotacao,
  }
}

export default useLeadScreenState;
